import type { ProfileRole, ProfileTeamData } from "@qendo/profile";
import Data from "~/util/data";

export class ProfileTeam extends Data implements ProfileTeamData {
    public constructor(
        public id: string,
        public profile_id: string,
        public team_role: ProfileRole,
        public name: string,
        public avatar: string | null = null,
        public emergency_contact: boolean = false,
    ) {
        super();
    }
}
